/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShippingLine
 */
export interface ShippingLine {
    /**
     * 
     * @type {string}
     * @memberof ShippingLine
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingLine
     */
    name: string;
}

/**
 * Check if a given object implements the ShippingLine interface.
 */
export function instanceOfShippingLine(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ShippingLineFromJSON(json: any): ShippingLine {
    return ShippingLineFromJSONTyped(json, false);
}

export function ShippingLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShippingLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ShippingLineToJSON(value?: ShippingLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

